import React from 'react';
import ReportTemplate from './ReportTemplate';
import { formatDate } from '../Utilities/GridTools';

const PTPReport = () => {
    const columnDefs = [
        { headerName: 'Debtor ID', field: 'debtorid' },
        { headerName: 'Collector', field: 'collector' },
        { headerName: 'PTP Amount', field: 'ptpAmt' },
        { headerName: 'PTP Date', field: 'ptpDate', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'List Date', field: 'listDate', valueFormatter: formatDate, filter: 'agDateColumnFilter' },
        { headerName: 'Project ID', field: 'projectID' }
    ];

    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/GetPTPReport`;

    return (
        <ReportTemplate columnDefs={columnDefs} apiUrl={apiUrl} reportName={'PTP Report'} />
    );
};

export default PTPReport;